// client/src/pages/user/WalletHistory.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function WalletHistory() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("all");
  const [type, setType] = useState("all");

  useEffect(() => {
    api.get("/wallet").then((res) => {
      setRows(res.data || []);
    });
  }, []);

  const filtered = rows.filter((r) => {
    if (status !== "all" && r.status !== status) return false;
    if (type !== "all" && r.type !== type) return false;
    return true;
  });

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Wallet History</h1>

      <div className="flex gap-3">
        <select
          className="input-glass bg-[#0b0f17] text-white"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="approved">Approved</option>
          <option value="pending">Pending</option>
          <option value="rejected">Rejected</option>
        </select>

        <select
          className="input-glass bg-[#0b0f17] text-white"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="all">All Types</option>
          <option value="credit">Credit</option>
          <option value="debit">Debit</option>
          <option value="refund">Refund</option>
        </select>
      </div>

      <table className="table-glass">
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th>Type</th>
            <th>Status</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          {filtered.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center py-6 text-gray-400">
                No transactions
              </td>
            </tr>
          ) : (
            filtered.map((t) => (
              <tr key={t._id}>
                <td>{new Date(t.createdAt).toLocaleString()}</td>
                <td>₹{t.amount}</td>
                <td>{t.type}</td>
                <td>{t.status}</td>
                <td>{t.reference || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
